// ServiceNow Certifications - Updated with official list
export const SERVICENOW_CERTIFICATIONS = [
  'Certified Application Developer',
  'Certified System Administrator',
  'Certified Platform Owner Associate',
  'Certified Implementation Specialist - Application Portfolio Management',
  'Certified Implementation Specialist - Cloud Provisioning and Governance',
  'Certified Implementation Specialist - Customer Service Management',
  'Certified Implementation Specialist - Data Foundations (CMDB and CSDM)',
  'Certified Implementation Specialist - Discovery',
  'Certified Implementation Specialist - Event Management',
  'Certified Implementation Specialist - Field Service Management',
  'Certified Implementation Specialist - Hardware Asset Management',
  'Certified Implementation Specialist - Human Resources',
  'Certified Implementation Specialist - IT Service Management',
  'Certified Implementation Specialist - Platform Analytics',
  'Certified Implementation Specialist - Risk and Compliance',
  'Certified Implementation Specialist - Software Asset Management',
  'Certified Implementation Specialist - Security Incident Response',
  'Certified Implementation Specialist - Service Mapping',
  'Certified Implementation Specialist - Service Provider',
  'Certified Implementation Specialist - Strategic Portfolio Management',
  'Certified Implementation Specialist - Third Party Risk Management',
  'Certified Implementation Specialist - Vulnerability Response',
  'Certified Master Architect',
  'Certified Technical Architect',
  'Accounts Payable Operations',
  'CSM Pro',
  'Data Foundations (CMDB and CSDM) Pro',
  'FSO Banking and Wealth Management Pro',
  'FSO Insurance Pro',
  'HAM with Telecommunications Network Inventory Pro',
  'Healthcare and Life Sciences Management Pro',
  'HR Pro',
  'ITSM Pro',
  'Public Sector Digital Services Pro',
  'Sourcing and Procurement Operations Pro',
  'Supplier Lifecycle Operations Pro',
  'Technology Provider Service Management Pro',
  'Telecommunications, Media, and Technology Service Management Pro',
  'Workflow Data Fabric Pro',
  'Now Assist for CSM Pro Plus',
  'Now Assist for HR Pro Plus',
  'Now Assist for IT Service Management Pro Plus'
];

// Certification Acronyms (for cards/summaries)
export const CERTIFICATION_ACRONYMS = {
  'Certified Application Developer': 'CAD',
  'Certified System Administrator': 'CSA',
  'Certified Platform Owner Associate': 'POA',
  'Certified Implementation Specialist - Application Portfolio Management': 'CIS-APM',
  'Certified Implementation Specialist - Cloud Provisioning and Governance': 'CIS-CPG',
  'Certified Implementation Specialist - Customer Service Management': 'CIS-CSM',
  'Certified Implementation Specialist - Data Foundations (CMDB and CSDM)': 'CIS-DF',
  'Certified Implementation Specialist - Discovery': 'CIS-DISCO',
  'Certified Implementation Specialist - Event Management': 'CIS-EM',
  'Certified Implementation Specialist - Field Service Management': 'CIS-FSM',
  'Certified Implementation Specialist - Hardware Asset Management': 'CIS-HAM',
  'Certified Implementation Specialist - Human Resources': 'CIS-HR',
  'Certified Implementation Specialist - IT Service Management': 'CIS-ITSM',
  'Certified Implementation Specialist - Platform Analytics': 'CIS-PA',
  'Certified Implementation Specialist - Risk and Compliance': 'CIS-RC',
  'Certified Implementation Specialist - Software Asset Management': 'CIS-SAM',
  'Certified Implementation Specialist - Security Incident Response': 'CIS-SIR',
  'Certified Implementation Specialist - Service Mapping': 'CIS-SM',
  'Certified Implementation Specialist - Service Provider': 'CIS-SP',
  'Certified Implementation Specialist - Strategic Portfolio Management': 'CIS-SPM',
  'Certified Implementation Specialist - Third Party Risk Management': 'CIS-TPRM',
  'Certified Implementation Specialist - Vulnerability Response': 'CIS-VR',
  'Certified Master Architect': 'CMA',
  'Certified Technical Architect': 'CTA',
  'Accounts Payable Operations': 'APO',
  'CSM Pro': 'CSM Pro',
  'Data Foundations (CMDB and CSDM) Pro': 'DF CMDB & CSDM Pro',
  'FSO Banking and Wealth Management Pro': 'FSO-BWM Pro',
  'FSO Insurance Pro': 'FSO-Ins Pro',
  'HAM with Telecommunications Network Inventory Pro': 'HAM & TNI Pro',
  'Healthcare and Life Sciences Management Pro': 'HLSM Pro',
  'HR Pro': 'HR Pro',
  'ITSM Pro': 'ITSM Pro',
  'Public Sector Digital Services Pro': 'PSDS Pro',
  'Sourcing and Procurement Operations Pro': 'SPO Pro',
  'Supplier Lifecycle Operations Pro': 'SLO Pro',
  'Technology Provider Service Management Pro': 'TPSM Pro',
  'Telecommunications, Media, and Technology Service Management Pro': 'TMTSM Pro',
  'Workflow Data Fabric Pro': 'WDF Pro',
  'Now Assist for CSM Pro Plus': 'NowAssist CSM Pro Plus',
  'Now Assist for HR Pro Plus': 'NowAssist HR Pro Plus',
  'Now Assist for IT Service Management Pro Plus': 'NowAssist ITSM Pro Plus'
};

// ServiceNow Modules
export const SERVICENOW_MODULES = [
  'ITSM (IT Service Management)',
  'ITOM (IT Operations Management)',
  'ITAM (IT Asset Management)',
  'CSM (Customer Service Management)',
  'HRSD (HR Service Delivery)',
  'SecOps (Security Operations)',
  'IRM (Integrated Risk Management)',
  'GRC (Governance, Risk & Compliance)',
  'SPM (Strategic Portfolio Management)',
  'APM (Agile Development)',
  'ITBM (IT Business Management)',
  'Field Service Management',
  'Platform & Core',
  'Integration Hub',
  'Flow Designer',
  'Service Portal',
  'Performance Analytics',
  'Virtual Agent',
  'Predictive Intelligence'
];

// Roles
export const RESOURCE_ROLES = [
  'Developer',
  'Consultant',
  'Architect',
  'Administrator',
  'Business Analyst',
  'Process Owner',
  'PMO (Project Manager)',
  'Product Owner',
  'Technical Lead',
  'Solution Architect',
  'Integration Specialist'
];

// Seniority Levels
export const SENIORITY_LEVELS = [
  'Junior',
  'Medior',
  'Senior',
  'Principal',
  'Lead'
];

// Currencies
export const CURRENCIES = [
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' }
];

// World Languages
export const LANGUAGES = [
  'English',
  'French',
  'German',
  'Spanish',
  'Italian',
  'Portuguese',
  'Dutch',
  'Russian',
  'Chinese (Mandarin)',
  'Japanese',
  'Korean',
  'Arabic',
  'Hindi',
  'Polish',
  'Swedish',
  'Danish',
  'Norwegian',
  'Finnish',
  'Turkish',
  'Greek',
  'Czech',
  'Romanian',
  'Hungarian',
  'Hebrew',
  'Thai',
  'Vietnamese',
  'Indonesian',
  'Malay'
];

// Project Types
export const PROJECT_TYPES = [
  'Implementation',
  'Advisory',
  'Administration',
  'Upgrade',
  'Pre-sales',
  'Audit',
  'Migration',
  'Training',
  'Support',
  'Custom Development',
  'Integration',
  'Optimization'
];

// Commercial Models
export const COMMERCIAL_MODELS = [
  'Time & Material',
  'Fixed Price'
];

// Budget Types
export const BUDGET_TYPES = [
  'Hourly',
  'Daily',
  'Monthly',
  'Full Project'
];

// Occupation Rates
export const OCCUPATION_RATES = [
  { value: 20, label: '20%' },
  { value: 40, label: '40%' },
  { value: 60, label: '60%' },
  { value: 80, label: '80%' },
  { value: 100, label: '100%' }
];

// Remote Percentages
export const REMOTE_PERCENTAGES = [
  { value: 0, label: '0%' },
  { value: 10, label: '10%' },
  { value: 20, label: '20%' },
  { value: 30, label: '30%' },
  { value: 40, label: '40%' },
  { value: 50, label: '50%' },
  { value: 60, label: '60%' },
  { value: 70, label: '70%' },
  { value: 80, label: '80%' },
  { value: 90, label: '90%' },
  { value: 100, label: '100%' }
];

// Partner Levels
export const PARTNER_LEVELS = [
  'Registered',
  'Specialist',
  'Premier',
  'Elite',
  'Global Elite'
];

// Countries where ServiceNow Partners are present (alphabetical order)
export const COUNTRIES = [
  'Algeria',
  'Argentina',
  'Australia',
  'Austria',
  'Bahamas',
  'Belarus',
  'Belgium',
  'Bermuda',
  'Bosnia and Herzegovina',
  'Brazil',
  'Bulgaria',
  'Canada',
  'Chile',
  'China',
  'Colombia',
  'Costa Rica',
  'Croatia',
  'Czech Republic',
  'Denmark',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Guatemala',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Ireland',
  'Israel',
  'Italy',
  'Japan',
  'Jordan',
  'Kenya',
  'Korea',
  'Kuwait',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Malaysia',
  'Mexico',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Norway',
  'Pakistan',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of Korea',
  'Romania',
  'Russian Federation',
  'Saudi Arabia',
  'Serbia',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'South Africa',
  'Spain',
  'Sweden',
  'Switzerland',
  'Taiwan',
  'Thailand',
  'Turkey',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States of America',
  'Uruguay',
  'Venezuela',
  'Yemen'
];

// New constants for enhanced project form

// Currency options (G20 + ServiceNow Partner countries)
export const CURRENCY_OPTIONS = [
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { code: 'AED', symbol: 'AED', name: 'UAE Dirham' },
  { code: 'ARS', symbol: '$', name: 'Argentine Peso' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'CLP', symbol: '$', name: 'Chilean Peso' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'COP', symbol: '$', name: 'Colombian Peso' },
  { code: 'CRC', symbol: '₡', name: 'Costa Rican Colón' },
  { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna' },
  { code: 'DKK', symbol: 'kr', name: 'Danish Krone' },
  { code: 'EGP', symbol: 'E£', name: 'Egyptian Pound' },
  { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar' },
  { code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint' },
  { code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah' },
  { code: 'ILS', symbol: '₪', name: 'Israeli Shekel' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'KRW', symbol: '₩', name: 'South Korean Won' },
  { code: 'KWD', symbol: 'KD', name: 'Kuwaiti Dinar' },
  { code: 'MXN', symbol: '$', name: 'Mexican Peso' },
  { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit' },
  { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone' },
  { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar' },
  { code: 'PEN', symbol: 'S/', name: 'Peruvian Sol' },
  { code: 'PHP', symbol: '₱', name: 'Philippine Peso' },
  { code: 'PKR', symbol: '₨', name: 'Pakistani Rupee' },
  { code: 'PLN', symbol: 'zł', name: 'Polish Zloty' },
  { code: 'QAR', symbol: 'QR', name: 'Qatari Riyal' },
  { code: 'RON', symbol: 'lei', name: 'Romanian Leu' },
  { code: 'RUB', symbol: '₽', name: 'Russian Ruble' },
  { code: 'SAR', symbol: 'SR', name: 'Saudi Riyal' },
  { code: 'SEK', symbol: 'kr', name: 'Swedish Krona' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
  { code: 'THB', symbol: '฿', name: 'Thai Baht' },
  { code: 'TRY', symbol: '₺', name: 'Turkish Lira' },
  { code: 'TWD', symbol: 'NT$', name: 'Taiwan Dollar' },
  { code: 'UAH', symbol: '₴', name: 'Ukrainian Hryvnia' },
  { code: 'UYU', symbol: '$U', name: 'Uruguayan Peso' },
  { code: 'VES', symbol: 'Bs.', name: 'Venezuelan Bolívar' },
  { code: 'ZAR', symbol: 'R', name: 'South African Rand' }
];

// Price types
export const PRICE_TYPES = [
  { value: 'hourly', label: 'Hourly' },
  { value: 'daily', label: 'Daily' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'fixed', label: 'Fixed (Full Project)' }
];

// Duration units
export const DURATION_UNITS = [
  { value: 'hours', label: 'Hours' },
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' }
];

// Remote zones
export const REMOTE_ZONES = [
  { value: 'country', label: 'Specific Country' },
  { value: 'region', label: 'Region (e.g., Europe, Asia)' },
  { value: 'worldwide', label: 'Worldwide' },
  { value: 'other', label: 'Other (specify)' }
];

// Regions for remote work
export const REGIONS = [
  'Europe',
  'North America',
  'South America',
  'Asia',
  'Africa',
  'Oceania',
  'Middle East'
];

// Language proficiency levels (CECRL/CEFR - Complete framework)
export const CECRL_LEVELS = [
  { value: 'A1', label: 'A1 - Beginner' },
  { value: 'A2', label: 'A2 - Elementary' },
  { value: 'B1', label: 'B1 - Intermediate' },
  { value: 'B2', label: 'B2 - Upper Intermediate' },
  { value: 'C1', label: 'C1 - Advanced' },
  { value: 'C2', label: 'C2 - Mastery / Native' }
];

// Backward compatibility alias
export const LANGUAGE_LEVELS = CECRL_LEVELS;

// Company types
export const COMPANY_TYPES = [
  { value: 'servicenow_partner', label: 'ServiceNow Partner' },
  { value: 'consulting_company', label: 'Consulting Company (non-partner)' },
  { value: 'recruitment_agency', label: 'Recruitment Agency' },
  { value: 'end_client', label: 'End Client (ServiceNow user)' },
  { value: 'servicenow_vendor', label: 'ServiceNow (Vendor)' },
  { value: 'other', label: 'Other' }
];

// Backward compatibility aliases
export const SUPPORTED_COUNTRIES = COUNTRIES;
export const SUPPORTED_CURRENCIES = CURRENCY_OPTIONS;
